var render = function render() {
  var _vm$data, _vm$data2, _vm$data3, _vm$data4;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block",
    staticStyle: {
      width: "100%"
    }
  }, [_vm.data ? _c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "data",
    staticClass: "demo-form",
    attrs: {
      model: _vm.data,
      "label-position": "top"
    }
  }, [_c("el-collapse", {
    model: {
      value: _vm.activeNames,
      callback: function ($$v) {
        _vm.activeNames = $$v;
      },
      expression: "activeNames"
    }
  }, [_c("el-collapse-item", {
    attrs: {
      title: "General Information",
      name: "general"
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "ID",
      prop: "id"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.data.id,
      callback: function ($$v) {
        _vm.$set(_vm.data, "id", $$v);
      },
      expression: "data.id"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Voucher No",
      prop: "ledgerInvoiceNumber"
    }
  }, [_c("el-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.data.ledgerInvoiceNumber,
      callback: function ($$v) {
        _vm.$set(_vm.data, "ledgerInvoiceNumber", $$v);
      },
      expression: "data.ledgerInvoiceNumber"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Branch"
    }
  }, [_c("el-input", {
    attrs: {
      value: ((_vm$data = _vm.data) === null || _vm$data === void 0 || (_vm$data = _vm$data.branch) === null || _vm$data === void 0 ? void 0 : _vm$data.code) || ((_vm$data2 = _vm.data) === null || _vm$data2 === void 0 ? void 0 : _vm$data2.branchId),
      disabled: ""
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Approval Status"
    }
  }, [_c("el-input", {
    attrs: {
      value: _vm.data.approvalStatus,
      disabled: ""
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Entered On"
    }
  }, [_c("el-input", {
    attrs: {
      value: _vm.formatDate((_vm$data3 = _vm.data) === null || _vm$data3 === void 0 ? void 0 : _vm$data3.createdTimestamp),
      disabled: ""
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Actual Date"
    }
  }, [_c("el-input", {
    attrs: {
      value: _vm.formatDate((_vm$data4 = _vm.data) === null || _vm$data4 === void 0 ? void 0 : _vm$data4.actualCreatedTimestamp),
      disabled: ""
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Dealer",
      prop: "dealerId"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      remote: "",
      loading: _vm.dealerListLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: "Search Dealer"
    },
    model: {
      value: _vm.data.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.data, "dealerId", $$v);
      },
      expression: "data.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(" " + _vm._s(dealer.name) + " - " + _vm._s(dealer.code || "") + " ")]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id) + " ")])]);
  }), 1)], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Payment Type",
      prop: "paymentType"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      name: "paymentType",
      placeholder: "Select"
    },
    model: {
      value: _vm.data.paymentType,
      callback: function ($$v) {
        _vm.$set(_vm.data, "paymentType", $$v);
      },
      expression: "data.paymentType"
    }
  }, _vm._l(_vm.paymentTypeOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 10
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Ledger Sub Type",
      prop: "paymentSubType"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      gap: "10px"
    }
  }, [_c("el-select", {
    staticStyle: {
      flex: "1"
    },
    attrs: {
      name: "paymentSubType",
      placeholder: "Select"
    },
    model: {
      value: _vm.data.paymentSubType,
      callback: function ($$v) {
        _vm.$set(_vm.data, "paymentSubType", $$v);
      },
      expression: "data.paymentSubType"
    }
  }, _vm._l(_vm.paymentSubTypeOptions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1), _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-plus"
    },
    on: {
      click: _vm.openDialog
    }
  })], 1)])], 1), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Action",
      prop: "action"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: "Select"
    },
    model: {
      value: _vm.data.action,
      callback: function ($$v) {
        _vm.$set(_vm.data, "action", $$v);
      },
      expression: "data.action"
    }
  }, _vm._l(_vm.actions, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.label,
        value: item.key
      }
    });
  }), 1)], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Amount",
      prop: "amount"
    }
  }, [_c("el-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      min: 0,
      "controls-position": "right"
    },
    model: {
      value: _vm.data.amount,
      callback: function ($$v) {
        _vm.$set(_vm.data, "amount", $$v);
      },
      expression: "data.amount"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Discount Amount",
      prop: "discountAmount"
    }
  }, [_c("el-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      min: 0,
      "controls-position": "right"
    },
    model: {
      value: _vm.data.discountAmount,
      callback: function ($$v) {
        _vm.$set(_vm.data, "discountAmount", $$v);
      },
      expression: "data.discountAmount"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "GST/Taxed Amount",
      prop: "taxedAmount"
    }
  }, [_c("el-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      min: 0,
      "controls-position": "right"
    },
    model: {
      value: _vm.data.taxedAmount,
      callback: function ($$v) {
        _vm.$set(_vm.data, "taxedAmount", $$v);
      },
      expression: "data.taxedAmount"
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Description",
      prop: "comments"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3
    },
    model: {
      value: _vm.data.comments,
      callback: function ($$v) {
        _vm.$set(_vm.data, "comments", $$v);
      },
      expression: "data.comments"
    }
  })], 1)], 1), _c("el-collapse-item", {
    attrs: {
      title: "Product Information",
      name: "products"
    }
  }, [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.data.CnDnProducts,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Product",
      width: "250"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (scope) {
        return [_c("el-select", {
          attrs: {
            filterable: "",
            remote: "",
            clearable: "",
            "remote-method": _vm._getProductList,
            loading: _vm.productListLoading,
            placeholder: "Search Product",
            size: "mini"
          },
          model: {
            value: _vm.selectedVariationId,
            callback: function ($$v) {
              _vm.selectedVariationId = $$v;
            },
            expression: "selectedVariationId"
          }
        }, _vm._l(_vm.products, function (product) {
          return _c("el-option-group", {
            key: product.id,
            attrs: {
              label: product.name
            }
          }, _vm._l(product.productsVariation, function (item) {
            return _c("el-option", {
              key: item.id,
              attrs: {
                label: product.name + " - " + item.name,
                value: item.id
              }
            }, [_c("span", [_vm._v(_vm._s(item.name))])]);
          }), 1);
        }), 1), _c("el-button", {
          attrs: {
            size: "mini",
            type: "success",
            icon: "el-icon-plus"
          },
          on: {
            click: function ($event) {
              return _vm.addVariation(scope);
            }
          }
        })];
      }
    }, {
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.name) + " ")];
      }
    }], null, false, 316222261)
  }), _c("el-table-column", {
    attrs: {
      label: "Variation",
      prop: "variationName",
      width: "170"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "MRP",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            precision: 2,
            step: 0.01
          },
          on: {
            change: function ($event) {
              return _vm.handleQuantity(scope.$index);
            }
          },
          model: {
            value: scope.row.mrp,
            callback: function ($$v) {
              _vm.$set(scope.row, "mrp", $$v);
            },
            expression: "scope.row.mrp"
          }
        })];
      }
    }], null, false, 3626146025)
  }), _c("el-table-column", {
    attrs: {
      label: "Quantity",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 1
          },
          on: {
            change: function ($event) {
              return _vm.handleQuantity(scope.$index);
            }
          },
          model: {
            value: scope.row.quantity,
            callback: function ($$v) {
              _vm.$set(scope.row, "quantity", $$v);
            },
            expression: "scope.row.quantity"
          }
        })];
      }
    }], null, false, 1307208121)
  }), _vm.data.action === "credit" ? _c("el-table-column", {
    attrs: {
      label: "Policy (%)",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 100,
            precision: 2,
            step: 0.01
          },
          on: {
            change: function ($event) {
              return _vm.handleQuantity(scope.$index);
            }
          },
          model: {
            value: scope.row.policiesDiscount,
            callback: function ($$v) {
              _vm.$set(scope.row, "policiesDiscount", $$v);
            },
            expression: "scope.row.policiesDiscount"
          }
        })];
      }
    }], null, false, 2974831906)
  }) : _vm._e(), _vm.data.action === "credit" ? _c("el-table-column", {
    attrs: {
      label: "MOQ (%)",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 100,
            precision: 2,
            step: 0.01
          },
          on: {
            change: function ($event) {
              return _vm.handleQuantity(scope.$index);
            }
          },
          model: {
            value: scope.row.moqDiscount,
            callback: function ($$v) {
              _vm.$set(scope.row, "moqDiscount", $$v);
            },
            expression: "scope.row.moqDiscount"
          }
        })];
      }
    }], null, false, 3975401495)
  }) : _vm._e(), _vm.data.action === "credit" ? _c("el-table-column", {
    attrs: {
      label: "Scheme (%)",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 100,
            precision: 2,
            step: 0.01
          },
          on: {
            change: function ($event) {
              return _vm.handleQuantity(scope.$index);
            }
          },
          model: {
            value: scope.row.schemesDiscount,
            callback: function ($$v) {
              _vm.$set(scope.row, "schemesDiscount", $$v);
            },
            expression: "scope.row.schemesDiscount"
          }
        })];
      }
    }], null, false, 489570562)
  }) : _vm._e(), _vm.data.action === "credit" ? _c("el-table-column", {
    attrs: {
      label: "Extra (%)",
      width: "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          attrs: {
            size: "mini",
            min: 0,
            max: 100,
            precision: 2,
            step: 0.01
          },
          on: {
            change: function ($event) {
              return _vm.handleQuantity(scope.$index);
            }
          },
          model: {
            value: scope.row.extraDiscount,
            callback: function ($$v) {
              _vm.$set(scope.row, "extraDiscount", $$v);
            },
            expression: "scope.row.extraDiscount"
          }
        })];
      }
    }], null, false, 890034174)
  }) : _vm._e(), _c("el-table-column", {
    attrs: {
      label: "Amount",
      width: "130",
      prop: "amount"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.amount) + " ")];
      }
    }], null, false, 1457177553)
  }), _c("el-table-column", {
    attrs: {
      label: "Action",
      width: "80",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-button", {
          attrs: {
            type: "danger",
            icon: "el-icon-delete",
            circle: "",
            size: "mini"
          },
          on: {
            click: function ($event) {
              return _vm.removeProduct(scope.$index);
            }
          }
        })];
      }
    }], null, false, 3905183642)
  })], 1)], 1)], 1), _vm.canManageApprovals ? _c("div", {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    }
  }, [_c("el-button", {
    attrs: {
      type: "success",
      loading: _vm.saveLoading
    },
    on: {
      click: _vm.handleSave
    }
  }, [_vm._v(" Save Changes ")])], 1) : _vm._e()], 1)], 1) : _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: true,
      expression: "true"
    }],
    staticStyle: {
      height: "200px"
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };